export enum BenefitViewType {
  Default = 'default',
  Results = 'results',
  Booking = 'booking',
  Cms = 'cms'
}
